import * as React from 'react';
import { Menu, MenuButton, MenuList, MenuItem, IconButton, Tooltip } from '@chakra-ui/react';
import { tiptapButtonStyle } from './TiptapButton';
import { useEditorContext } from '../editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
   faSlash,
   faSquareFull,
   faFillDrip,
   faChevronDown,
} from '@fortawesome/pro-regular-svg-icons';
import { shadow } from '@dozuki/web-js/primitives';
import { useLocalization } from '~/framework';

export const TableBackgroundColorDropdown = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();
   const menuItemStyle = (color: string) => {
      if (editor.isActive({ backgroundColor: color })) {
         return {
            cursor: 'not-allowed',
            bg: 'gray.100',
         };
      }
   };
   const whiteButtonIconStyle = {
      color: '#FFFFFF',
      padding: '2px',
      backgroundColor: '#858585',
   };

   const menuIconStyle = (color: string) => {
      return {
         color: color == '#FFFFFF' ? '#E3E8ED' : color,
         backgroundColor: color,
         marign: 0,
      };
   };

   const resetIcon = (
      <span className="fa-layers fa-lg">
         <FontAwesomeIcon icon={faSlash} transform="left-2 grow-1" />
         <FontAwesomeIcon icon={faSquareFull} />
      </span>
   );

   return (
      <Menu onClose={() => setTimeout(() => editor.commands.focus(), 50)}>
         <Tooltip placement="top-start" label={_js('Background Color')}>
            <MenuButton
               as={IconButton}
               icon={
                  <FontAwesomeIcon
                     icon={faFillDrip}
                     style={
                        editor.storage.backgroundColor.currentColor == '#FFFFFF'
                           ? whiteButtonIconStyle
                           : { color: editor.storage.backgroundColor.currentColor }
                     }
                  />
               }
               // @ts-ignore (MenuButton is missing a TS definition for the rightIcon prop)
               // See https://github.com/chakra-ui/chakra-ui/issues/231
               rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
               padding={1}
               {...tiptapButtonStyle}
            />
         </Tooltip>
         <MenuList minW="auto" padding={0} boxShadow={shadow[3]}>
            <MenuItem
               onClick={() => editor.commands.unSetBackgroundColor()}
               iconSpacing={0}
               icon={resetIcon}
            />
            {editor.storage.backgroundColor.colors.map((color: string) => (
               <MenuItem
                  key={color}
                  onClick={() => editor.commands.setBackgroundColor(color)}
                  sx={menuItemStyle(color)}
                  iconSpacing={0}
                  icon={
                     <FontAwesomeIcon icon={faSquareFull} size="lg" style={menuIconStyle(color)} />
                  }
               />
            ))}
         </MenuList>
      </Menu>
   );
};
